import { useState, useEffect, useCallback } from 'react'
import { api } from '@api/client'
import { appsyncQuery } from '@api/appsync-client'

const GET_ORG_TREE = `
  query GetOrgTree {
    getOrgTree {
      tree {
        userId name email team sessionCount lastActiveAt
        reports {
          userId name email team sessionCount lastActiveAt
          reports {
            userId name email team sessionCount lastActiveAt
            reports { userId name email team sessionCount lastActiveAt reports { userId name email } }
          }
        }
      }
      orphans { userId email name }
    }
  }
`

export function useOrgTree() {
  const [tree, setTree] = useState([])
  const [orphans, setOrphans] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const load = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const data = await appsyncQuery(GET_ORG_TREE)
      const result = data.getOrgTree
      setTree(result.tree || [])
      setOrphans(result.orphans || [])
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { load() }, [load])

  const assignManager = useCallback(async (userId, managerId) => {
    await api.adminAssignManager(userId, managerId)
    load()
  }, [load])

  return { tree, orphans, loading, error, assignManager, reload: load }
}
